/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */

    save: "ذخیره",
    /* Module special vocabulary */
    "rebit-accounts": {
        menu: {
            list: 'حساب‌ها',
        },
        table_titles: {
            id: 'شناسه',
            holder: "نام دارنده",
            currency: 'ارز',
            exchange: 'صرافی',
            cash: 'نقدی',
            type: 'نوع',
            bank: 'بانک / صرافی',
            network: 'شبکه',
            owner_operator: 'توسط اپراتور',
            status: 'وضعیت',
            is_depositable: 'قابل واریز',
            description: 'برچسب',
            opening_balance: 'موجودی اولیه',
            real_balance: 'موجودی واقعی',
            ideal_balance: 'موجودی ایده‌آل',
            monthly_turnover_limit: 'سقف گردش ماهانه',
            created_at: 'زمان ثبت',
            updated_at: 'زمان به‌روزرسانی',
            setting: 'ویرایش',
        },
        auth_params: "پارامترهای احراز هویت",
        total_balances: {
            index: "موجودی حساب‌ها",
            currency: "ارز",
            total_actual_balance: "مجموع موجودی واقعی",
            usdt_value: "ارزش به USDT",
            nzd_value: "ارزش به NZD",
            total: "مجموع",
        },
        bank_account_number: 'شماره حساب بانکی',
        wallet_address: 'آدرس کیف پول',
        create: 'ایجاد حساب',
        edit: 'ویرایش حساب',
    },
    "wallet-addresses": {
        menu: {
            index: 'آدرس‌های کیف پول',
            create: 'آدرس کیف پول جدید',
            list: 'آدرس‌های کیف پول'
        },
        table_titles: {
            id: 'شناسه',
            owner: 'مالک',
            address: 'آدرس',
            network: 'شبکه',
            is_active: 'وضعیت',
            setting: 'ویرایش / حذف',
        },
        edit: 'ویرایش آدرس کیف پول'
    }
}
